import React, { useState } from 'react';
import { Form } from "reactstrap";


const EmailOthersForm = (props) => {

    const [isInvalid, setIsInvalid] = useState(false);
    const [formState, setFormState] = useState({
        email: ''
    });

    const submitForm = async (event) => {
        event.preventDefault();
        if(validateEmail(formState.email)) {
            props.handler(formState.email);
        } else {
            setIsInvalid(true);
        }
        
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...formState };
        formFields[name] = value;
        setFormState(formFields);
    }

    const validateEmail = (email) => {
        //eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    return (
        <Form onSubmit={submitForm} className="kt-form kt-form--label-right mt-3">
            <label>Enter the email address of person you'd like to share.</label>
            <div className="input-group">
                <input type="text" className="form-control" placeholder="Email" name="email" value={formState.email || ''} onChange={handleInputChange} />
                <div className="input-group-append">
                    <button className="btn btn-primary" type="submit">SEND</button>
                </div>
            </div>
            {isInvalid ? <span className="text-danger">Please enter a valid email</span> : <></>}
        </Form>);
}
export default EmailOthersForm;